import { useTranslation } from "react-i18next";
import { CustomButton, CustomModal, CustomTypography } from "sipli-fleet-core/components";
import activatedIcon from "src/assets/tachograph-activated.png";
import deactivateIcon from "src/assets/tachograph-deactivate.png";
import "./TachographActivationModal.css";

interface TachographActivationModalProps {
  mode: "activated" | "deactivate" | null;
  loading?: boolean;
  scope?: "customer" | "vehicle";
  onClose: () => void;
  onConfirm: () => void;
}

const TachographActivationModal = ({
  mode,
  loading = false,
  scope = "customer",
  onClose,
  onConfirm,
}: TachographActivationModalProps) => {
  const { t } = useTranslation();
  const deactivating = mode === "deactivate";

  return (
    <CustomModal
      open={mode !== null}
      width={473}
      centered
      closable={false}
      showFooter={false}
      onCancel={onClose}
      maskClosable={!loading}
      keyboard={!loading}
      rootClassName="tachograph-activation-modal"
    >
      <div className="flex flex-col items-center gap-[32px] text-center">
        <div className={`flex w-full flex-col items-center ${deactivating ? "gap-[16px]" : "gap-[24px]"}`}>
          <div className="flex h-[65px] w-[113px] items-center justify-center">
            <img
              src={deactivating ? deactivateIcon : activatedIcon}
              alt=""
              width={113}
              height={51}
            />
          </div>
          <div className="flex w-full flex-col gap-[8px]">
            <CustomTypography.CustomText className="!text-[19.93px] !leading-[28px] !font-bold !text-black">
              {t(deactivating ? "tachograph_deactivate_title" : scope === "vehicle" ? "tachograph_activated" : "tachograph_service_enabled")}
            </CustomTypography.CustomText>
            {deactivating && (
              <CustomTypography.CustomText className="!text-[14px] !leading-[18px] !text-black">
                {t(scope === "vehicle" ? "tachograph_vehicle_remove_warning" : "tachograph_customer_remove_warning")}
              </CustomTypography.CustomText>
            )}
          </div>
        </div>
        <div className="flex w-full gap-[8px]">
          <CustomButton
            type="secondary"
            label={t(deactivating ? "deny" : "close")}
            className="!h-[32px] flex-1"
            onClick={onClose}
            disabled={loading}
          />
          {deactivating && (
            <CustomButton
              type="primary"
              danger
              label={t("tachograph_deactivate")}
              className="!h-[32px] flex-1"
              onClick={onConfirm}
              loading={loading}
            />
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default TachographActivationModal;
